import { useCallback } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

import { ReactComponent as CalendarIcon } from './assets/icons/calendar.svg';

const activeStyle = {
  backgroundColor: `#D6E4FF`,
};

export const CustomDatePicker = ({ selectedDate, selectDate, dates, style, withIcon, size = 'middle' }) => {
  const cellRender = useCallback(
    (current, info) => {
      const currentDate = dayjs(current).format('YYYY-MM-DD');

      if (info.type !== 'date') {
        return info.originNode;
      }

      return (
        <div className="ant-picker-cell-inner" style={dates.includes(currentDate) ? activeStyle : {}}>
          {current.date()}
        </div>
      );
    },
    [dates],
  );

  return (
    <DatePicker
      cellRender={cellRender}
      format="MMM D, YYYY"
      value={dayjs(selectedDate)}
      rootClassName={'custom-date-picker custom-date-picker--filter'}
      size={size}
      onChange={(date) => {
        selectDate(dayjs(date).format('YYYY-MM-DD'));
      }}
      allowClear={false}
      suffixIcon={withIcon ? <CalendarIcon /> : null}
      style={style}
      inputReadOnly={true}
      showToday={false}
      disabledDate={(current) => !dates.includes(dayjs(current).format('YYYY-MM-DD'))}
      disabled={!dates || dates.length === 0}
    />
  );
};
